<span>{{ label }}<ng-container *ngIf="editMode && required">*</ng-container>:</span>

<ng-container *ngIf="!editMode; else editField">
  <ng-content></ng-content>
</ng-container>

<ng-template #editField>
  <div class="field-edit">
    <ng-container *ngIf="isInput; else Select">
      <input class="value-box no-background" [type]="type" [value]="value" (input)="onInput($event)" (blur)="onTouched()" />
    </ng-container>

    <ng-template #Select>
      <select class="value-box no-background" [value]="value" (change)="onSelect($event)" (blur)="onTouched()">
        <option *ngFor="let opt of options" [ngValue]="opt.value" [selected]="opt.value === value">
          {{ opt.translate ? (opt.label | translate) : opt.label }}
        </option>
      </select>
    </ng-template>

    <div class="error-message" *ngIf="requiredError">
      <span>{{ "common.required" | translate }} </span>
    </div>
  </div>
</ng-template>
